package org.example.project.client.model

import kotlinx.serialization.Serializable

@Serializable
enum class ActivityStatus {
    DRAFT,
    PUBLISHED;

    companion object {
        fun fromString(value: String): ActivityStatus {
            return entries.firstOrNull { it.name.equals(value.trim(), ignoreCase = true) }
                ?: throw IllegalArgumentException("Unknown activity status: '$value'")
        }
    }
}

@Serializable
data class ActivityResponse(
    val id: String,
    val name: String,
    val description: String,
    val minAge: Int,
    val maxAge: Int,
    val category: String,
    val durationMinutes: Int,
    val status: ActivityStatus,
    val createdAt: String,
    val updatedAt: String,
    val videoUrl: String? = null
)

@Serializable
data class ActivityListResponse(
    val items: List<ActivityResponse>,
    val total: Int,
    val limit: Int,
    val offset: Int
)

@Serializable
data class ActivityFilters(
    val search: String? = null,
    val age: Int? = null,
    val minAge: Int? = null,
    val maxAge: Int? = null,
    val category: String? = null,
    val minDuration: Int? = null,
    val maxDuration: Int? = null,
    val sort: String? = null,
    val limit: Int? = null,
    val offset: Int? = null
)

@Serializable
data class CreateActivityRequest(
    val name: String,
    val description: String,
    val minAge: Int,
    val maxAge: Int,
    val category: String,
    val durationMinutes: Int,
    val videoUrl: String? = null
)

@Serializable
data class UpdateActivityRequest(
    val name: String,
    val description: String,
    val minAge: Int,
    val maxAge: Int,
    val category: String,
    val durationMinutes: Int,
    val videoUrl: String? = null
)
